import { render } from "./OrderQueries.vue?vue&type=template&id=7f0129b3&scoped=true"
import script from "./OrderQueries.vue?vue&type=script&lang=js"
export * from "./OrderQueries.vue?vue&type=script&lang=js"

import "./OrderQueries.vue?vue&type=style&index=0&id=7f0129b3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0129b3"]])

export default __exports__